<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="t_name">
    <p class="cn">目录</p>
    <p class="en">contents</p>
  </div>
  <p class="detail">
    本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
    {{ taskSum }} 份。
  </p>
  <div class="item" v-for="({ title, child }, index) in catalogue" :key="index">
    <div class="title">
      <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
      <div class="name">{{ title }}</div>
    </div>
    <div class="child" v-if="Array.isArray(child)">
      <div
        class="child-item"
        v-for="({ title, num }, childIndex) in child"
        :key="childIndex"
      >
        <p class="child-item-name">{{ title }}</p>
        <div class="hr"></div>
        <p class="child-item-number">
          {{ `${num}`.padStart(2, '0') }}
        </p>
      </div>
    </div>
  </div>
  <div class="_bg"></div>
</template>

<script setup lang="tsx">
import { watch } from 'vue';
type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
._bg {
  content: '';
  width: 136px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: var(--theme-color-1);
  z-index: 1;
}
.t_name {
  width: 136px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 130px;
  left: 0;
  color: #fff;
  font-weight: 500;
  z-index: 2;
  .cn {
    font-size: 50px;
    writing-mode: vertical-lr;
    letter-spacing: 40px;
  }
  .en {
    font-size: 38px;
    writing-mode: vertical-lr;
    text-transform: uppercase;
    letter-spacing: 20px;
    text-indent: 60px;
  }
}
.detail {
  font-size: 16px;
  font-weight: 500;
  line-height: 36px;
  color: #3e3e3e;
  padding-bottom: 70px;
}

.item {
  padding-top: 20px;
  padding-bottom: 20px;
  .title {
    display: flex;
    align-items: center;
    padding: 20px 0;
    padding-bottom: 4px;
    .index {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 55px;
      height: 55px;
      background-color: var(--theme-color-1);
      font-size: 32px;
      font-weight: 500;
      color: #ffffff;
      border-radius: 100%;
      margin-right: 44px;
      flex-shrink: 0;
    }
    .name {
      font-size: 30px;
      font-weight: 500;
      line-height: 69px;
      color: #222222;
      @include line_clamp(1);
    }
  }
  .child {
    padding-left: 100px;
    .child-item {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #222222;
      padding: 12px 0;
    }
    .hr {
      flex-grow: 1;
      height: 1pt;
      background-color: #142666;
      margin-left: 18px;
      margin-right: 6px;
    }
    .child-item-name {
      max-width: 60%;
      @include line_clamp(1);
    }
    .child-item-number {
    }
  }
}
</style>
